export function stripMarkdown(text) {
  if (typeof text !== 'string') return '';
  return text
    .replace(/```[\s\S]*?```/g, ' ')
    .replace(/~~~[\s\S]*?~~~/g, ' ')
    .replace(/`([^`]*)`/g, '$1')
    .replace(/!\[([^\]]*)\]\([^)]*\)/g, '$1')
    .replace(/\[([^\]]*)\]\([^)]*\)/g, '$1')
    .replace(/^\s{0,3}>\s?/gm, '')
    .replace(/^\s{0,3}#{1,6}\s+/gm, '')
    .replace(/^\s{0,3}([-*_])\s*\1\s*\1[\s*_-]*$/gm, ' ')
    .replace(/^\s{0,3}\|[ \t]*:?-{2,}:?[ \t]*(?:\|[ \t]*:?-{2,}:?[ \t]*)*\|?[ \t]*$/gm, ' ')
    .replace(/^\s{0,3}[-*+]\s+/gm, '')
    .replace(/^\s{0,3}\d+[.)]\s+/gm, '')
    .replace(/^\s*\|(.+)\|[ \t]*$/gm, (_m, row) => row.replace(/\|/g, ' '))
    .replace(/(\*\*\*|___)([\s\S]+?)\1/g, '$2')
    .replace(/(\*\*|__)([\s\S]+?)\1/g, '$2')
    .replace(/(\*|_)([^\s*_][\s\S]*?)\1/g, '$2')
    .replace(/~~([\s\S]+?)~~/g, '$1')
    .replace(/<[^>]+>/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}

export function excerpt(text, maxLength = 150) {
  const stripped = stripMarkdown(text);
  if (stripped.length <= maxLength) return stripped;
  const slice = stripped.slice(0, maxLength);
  const lastSpace = slice.lastIndexOf(' ');
  const base = lastSpace > maxLength * 0.5 ? slice.slice(0, lastSpace) : slice;
  return `${base.trimEnd()}...`;
}

// A post card is collapsed to a few lines and grows on demand, so anything past this
// length of *rendered* text needs a "read more" control. Measured on the stripped text
// rather than the raw Markdown: a wall of syntax characters should not count as reading,
// and what the reader actually sees is the rendered output.
export const POST_CLAMP_CHARS = 340;

// Comments are far shorter than posts and are read in a list, so they collapse much
// earlier. Same measurement basis as posts for the same reason.
export const COMMENT_CLAMP_CHARS = 100;

export function exceedsClampLength(text, maxLength) {
  return stripMarkdown(text).length > maxLength;
}

export function shouldClampPost(text, maxLength = POST_CLAMP_CHARS) {
  return exceedsClampLength(text, maxLength);
}

export function shouldClampComment(text, maxLength = COMMENT_CLAMP_CHARS) {
  return exceedsClampLength(text, maxLength);
}

